exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thumb-image .image-invisible .v-image__image {\r\n  opacity: 0.5;\r\n  filter: grayscale(1);\n}\r\n", ""]);

// exports
